import React, { useEffect, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { getUserSession } from '../../../util/core/Session';
import config from '../../../../application/config/config';
import Fetch from '../../../util/core/Fetch';
import { useNavigate, useParams } from 'react-router-dom';

const TableComponent = () => {
  const [tutorials, setTutorials] = useState([]);
  const session = getUserSession();
  const navigate = useNavigate();
  const { id } = useParams();

  const pathBackEnd = 'core/tutorial/';
  const paths = {
    endpoint: config.endpoints.backend + pathBackEnd + 'getById',
  };

  const reference = id;

  useEffect(() => {
    const fetchTutorials = async () => {
      try {
        const response = await Fetch.post(paths.endpoint, {
          core_application_instance_id: session.user.application_instance_id,
          id: reference,
        });

        setTutorials(response);
      } catch (error) {
        console.error('Erro ao buscar tutoriais:', error);
      }
    };

    fetchTutorials();
  }, [session.user.application_instance_id]);

  const handleNavigate = (id, reference, title) => {
    navigate(`/core/tutorialscard/form/${reference}/${id}`, { state: { title: title } });
  };

  const handleBack = () => {
    navigate(-1);
  };
  const isGeneralAdmOrPlatAdm = session.user.application_instance_id === '1b0996dc-8ad5-4f6f-8393-539fffc02b9f' || session.user.application_instance_id === '013aee58-14f6-4f74-ada7-e95e8eadfcf9';

  const filteredItens = useMemo(() => {
    if (isGeneralAdmOrPlatAdm) {
      return tutorials?.children;
    } else {
      const filtered = tutorials.children?.filter((item) => item.published === "1" );
      return filtered;
    }
  },[tutorials])

  return (
    <section className="content" style={{ marginTop: '30px' }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card card-outline card-info">
              <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 className="card-title">
                  {<i className='fa-solid fa-pen-to-square mr-1'></i>}Tutoriais
                </h4>
                <button onClick={handleBack} style={{marginLeft: 'auto', padding: '8px 16px', color: '#fff', backgroundColor: '#6c757d', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                  Voltar
                </button>
              </div>
              <div style={{ fontFamily: 'Arial, sans-serif', width: '98%', margin: 'auto', marginTop: '10px' }}>
                <div style={{ padding: '20px', backgroundColor: '#ffffff', marginBottom: '20px', borderLeft: '5px solid #007bff' }}>
                  <p style={{ margin: '0 0 10px 0', fontSize: '14px' }}>Módulo:</p>
                  <p>{tutorials.title}</p>
                  <p style={{ margin: '0 0 10px 0', fontSize: '14px' }}>Descrição:</p>
                  <p>{tutorials.description}</p>
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', boxShadow: '0px 0px 10px rgba(0,0,0,0.1)' }}>
                  <thead style={{ padding: '30px 10px' }}>
                    <tr>
                      <th style={{ textAlign: 'left', padding: '30px 24px', backgroundColor: '#fafafa', fontSize: '12px' }}>Nome do Conteúdo</th>
                      <th style={{ textAlign: 'left', padding: '30px 24px', backgroundColor: '#fafafa', fontSize: '12px' }}>Descrição</th>
                      <th style={{ textAlign: 'left', padding: '30px 24px', backgroundColor: '#fafafa', fontSize: '12px' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredItens?.map((child, index) => (
                      <tr key={child._id} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9', borderTop: '1px solid #ebebeb' }}>
                        <td style={{ padding: '16px 24px', fontSize: '12px' }}>{child.title}</td>
                        <td style={{ padding: '16px 24px', fontSize: '12px' }}>{child.description || 'N/A'}</td>
                        <td style={{ padding: '16px 24px', fontSize: '12px' }}>
                          <button onClick={() => handleNavigate(reference, child._id, child.title)} style={{ padding: '8px 16px', color: '#fff', backgroundColor: '#007bff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={faPlay} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TableComponent;
